import { render, staticRenderFns } from "./yidi.vue?vue&type=template&id=3e334d38&scoped=true&"
import script from "./yidi.vue?vue&type=script&lang=js&"
export * from "./yidi.vue?vue&type=script&lang=js&"
import style0 from "./yidi.vue?vue&type=style&index=0&id=3e334d38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e334d38",
  null
  
)

export default component.exports